import { render, staticRenderFns } from "./crudQuerys.vue?vue&type=template&id=d6d10ea8&scoped=true"
import script from "./crudQuerys.vue?vue&type=script&lang=js"
export * from "./crudQuerys.vue?vue&type=script&lang=js"
import style0 from "./crudQuerys.vue?vue&type=style&index=0&id=d6d10ea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d10ea8",
  null
  
)

export default component.exports